import menus from 'netxcore@netx/core-app/menus';
import Menu from '@netx/core/lib/netx-menu';

menus.headerMenu = new Menu({
	actions: [],
});

export default menus;
